import { render } from "./Shops.vue?vue&type=template&id=0fbbc396&scoped=true"
import script from "./Shops.vue?vue&type=script&lang=js"
export * from "./Shops.vue?vue&type=script&lang=js"

import "./Shops.vue?vue&type=style&index=0&id=0fbbc396&scoped=true&lang=css"
import "./Shops.vue?vue&type=style&index=1&id=0fbbc396&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbbc396"]])

export default __exports__